<script setup>
import Vue, {computed, inject, ref} from "vue";
import DuplicateTracker from "@/components/trackers/DuplicateTracker.vue";
import accountTypes from "@/constants/accountTypes";
import {useStore} from "vue2-helpers/vuex";
import SelectFolder from "@/components/manage/SelectTrackerFolder.vue";
import trackersFoldersService from "@/services/trackers-folders.service";
import trackersService from "@/services/trackers.service";
import {useRouter} from "vue2-helpers/vue-router";
import TaskEdit from "@/components/tasks/TaskEdit.vue";
import {trackerTypes} from "@/constants/trackers";

// import ManageColumns from "@/components/manage/ManageColumns.vue";

const emit = defineEmits(['updateTasks']);
const store = useStore();
const router = useRouter();

const tracker = inject('tracker');
const displayType = inject("displayType");
const trackerId = tracker.value.id;
const duplicateTrackerModal = ref(null);
const editTaskModal = ref(null);
const selectFolderModal = ref(null);

const ownerEnterprise = computed(() => tracker.value.company_owner_type === accountTypes.ENTERPRISE);
const canEditTracker = computed(() => tracker.value.user_permissions.includes('tracker-edit'));

async function addToFolder(folder) {
    await trackersFoldersService.addTrackers(folder.id, [trackerId]);

    Vue.notify({
        group: 'app',
        type: 'success',
        duration: 5000,
        text: "Tracker added to " + folder.name + " folder."
    })
}

async function deleteTracker() {
    if (confirm("Delete tracker?")) {
        await trackersService.delete(trackerId);
        router.push('/trackers');
    }
}

async function archiveTracker() {
    await trackersService.update(trackerId, {status: 'archive'});
    tracker.value.status = 'archive';
}

async function unArchiveTracker() {
    await trackersService.update(trackerId, {status: 'draft'});
    tracker.value.status = 'draft';
}
</script>

<template>
    <div>
        <b-dropdown class="icons-list dropdown-original dropdown-original--xs dropdown-original--white" text="Manage" variant="link" no-caret>
            <b-dropdown-text
                v-if="displayType === 'list'"
                class="icons-list__edit"
                id="edit-columns-action"
                style="padding: 0"
            />

            <b-dropdown-item
                class="icons-list__copy"
                @click="duplicateTrackerModal.open(tracker.id, tracker.name, tracker.type)"
            >
                Duplicate tracker
            </b-dropdown-item>

            <b-dropdown-item
                v-if="ownerEnterprise && !store.getters.settings.disable_tasks"
                class="icons-list__task"
                @click="editTaskModal.open()"
            >
                Add task
            </b-dropdown-item>

            <b-dropdown-item
                v-if="canEditTracker"
                class="icons-list__add-folder"
                @click="selectFolderModal.open()"
            >
                Add to Folder
            </b-dropdown-item>

            <b-dropdown-item
                v-if="canEditTracker"
                class="icons-list__delete"
                @click="deleteTracker"
            >
                Delete tracker
            </b-dropdown-item>

            <b-dropdown-item v-if="canEditTracker && tracker.status !== 'archive'" @click="archiveTracker" class="icons-list__archive">
                Archive
            </b-dropdown-item>

            <b-dropdown-item v-if="canEditTracker && tracker.status === 'archive'" @click="unArchiveTracker" class="icons-list__archive">
                Un-Archive
            </b-dropdown-item>

            <b-dropdown-item 
                v-if="tracker.type === trackerTypes.PUBLIC" 
                target="_blank" 
                :href="'/trackers/' + tracker.id + '/preview'"
                class="icons-list__preview"
                >
                Preview
            </b-dropdown-item>
        </b-dropdown>

        <DuplicateTracker
            ref="duplicateTrackerModal"
        />

        <TaskEdit
            ref="editTaskModal"
            :tracker-id="tracker.id"
            @saved="emit('updateTasks')"
        />

        <SelectFolder
            ref="selectFolderModal"
            @folderSelected="addToFolder"
        />
    </div>
</template>

<style scoped>

</style>
